import { takeLatest } from 'redux-saga/effects';
import { updateMeasuredCookie } from './actions';
import { MeasuredCookie } from './MeasuredCookie';

function* handleUpdateCookie({
  payload,
}: ReturnType<typeof updateMeasuredCookie>) {
  if (!payload) {
    return;
  }
  const { cookieDim, cookieType, dims } = payload;

  const size =
    cookieDim === 'both'
      ? ([dims.width, dims.height] as [number, number])
      : dims[cookieDim!];

  MeasuredCookie.write(cookieType!, size);
}

export default function* saga() {
  yield takeLatest(updateMeasuredCookie, handleUpdateCookie);
}
